export default __webpack_public_path__ + "f8ac708976496a0a1f9dc326b5f2070d.png";